/*
 * Free-gift variant IDs. Mirrored in sections/cart-drawer.liquid and
 * sections/main-cart-items.liquid where the quantity controls are locked
 * for these lines. Update all three locations together if the promo
 * changes.
 */
window.GIFT_VARIANT_IDS = [
  45875292209254, // Moutai Shot Glass Set ($599.99 tier)
  45875291488358, // Moutai Extended Drinkware Set ($1,099.99 tier)
  45875292045414  // Moutai Premium Cup Display Set (vintage promo)
];

/*
 * On page load, if any gift variant is in the cart at quantity > 1,
 * silently reduce it to 1. Guards against:
 *   - Existing carts from before the quantity lock was deployed
 *   - Edge cases where a customer added the gift SKU as a paid item
 *     BEFORE clicking the free-gift button in the drawer
 * Reducing quantity forces Shopify's Buy X Get Y allocation to give one
 * free item slot to each distinct gift variant instead of stacking two
 * free slots on the same product.
 */
window.enforceGiftQuantityLimit = function() {
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(r => r.json())
    .then(cart => {
      const overs = cart.items.filter(i =>
        window.GIFT_VARIANT_IDS.indexOf(i.variant_id) !== -1 && i.quantity > 1
      );
      if (overs.length === 0) return;
      // Sequentially cap each over-quota gift line at 1.
      overs.reduce((chain, item) =>
        chain.then(() => fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: item.variant_id, quantity: 1 })
        }))
      , Promise.resolve()).then(() => {
        // Refresh the drawer if it exists so the display matches server state.
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          return fetch('/cart.js?sections=cart-drawer,cart-icon-bubble', {
            headers: { 'Accept': 'application/json' }
          }).then(r => r.json()).then(state => cartDrawer.renderContents(state));
        }
      }).catch(err => console.error('Gift quantity enforcement error:', err));
    })
    .catch(err => console.error('Gift quantity check error:', err));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', window.enforceGiftQuantityLimit);
} else {
  window.enforceGiftQuantityLimit();
}

window.addGiftToCart = function(giftType) {
  const giftVariants = {
    'moutai-shot-glass-set': '45875292209254',        // $599.99 tier
    'moutai-extended-drinkware-set': '45875291488358', // $1,099.99 tier
    'moutai-premium-cup-display': '45875292045414'    // Vintage promo
  };

  const variantId = giftVariants[giftType];
  if (!variantId) {
    console.error('Invalid gift type');
    return;
  }

  /*
   * Request the FULL cart-drawer section (not just cart-drawer-items) in the
   * add-to-cart response so we can re-render the entire drawer wrapper. The
   * outer wrapper contains the free-gift button block, which needs to update
   * after adding a gift so the button switches to the "✓ Added" indicator.
   * Requesting only cart-drawer-items would refresh the items table but
   * leave the button block stale.
   */
  const body = JSON.stringify({
    items: [
      {
        id: variantId,
        quantity: 1
      }
    ],
    sections: ['cart-drawer', 'cart-icon-bubble']
  });

  fetch(`${routes.cart_add_url}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body
  })
  .then(response => response.json())
  .then(state => {
    if (state.errors) {
      console.error('Error adding gift to cart:', state.errors);
      return;
    }

    // Directly call the cart-drawer's renderContents so the full drawer
    // (including our free-gift button block) redraws from the fresh state.
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(state);
    }

    // Also refresh the cart icon bubble in the header.
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble && state.sections && state.sections['cart-icon-bubble']) {
      const parsed = new DOMParser().parseFromString(state.sections['cart-icon-bubble'], 'text/html');
      const section = parsed.querySelector('.shopify-section');
      cartIconBubble.innerHTML = section ? section.innerHTML : state.sections['cart-icon-bubble'];
    }

    // Keep publishing the cartUpdate event so any other subscribers
    // (analytics, other custom listeners) still fire.
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'gift-cart',
      cartData: state
    });
  })
  .catch(error => {
    console.error('Error:', error);
  });
}
